import StepId from "@/model/progress/StepId"
import RouteType from "@/model/route/RouteType"
import { applicationState } from "@/state"

export default [
    {
        name: "startPrimaryProvider",
        path: "/providers/:providerKey/modes/:mode/primary/start",
        redirect: "/providers/:providerKey/modes/:mode/application",
    },
    {
        name: "startProvider",
        path: "/providers/:providerKey/modes/:mode/start",
        redirect: "/providers/:providerKey/modes/:mode/application",
    },
    {
        name: "switchProvider",
        path: "/providers/:providerKey/modes/:mode/switch",
        component: () => import("@/views/apply/SwitchProviderView"),
    },

    {
        name: "application",
        path: "/providers/:providerKey/modes/:mode/application",
        meta: {
            routeType: RouteType.FIELD_COLLECTION,
            step: StepId.APPLICANT_INFO,
        },
        component: () => import("@/views/apply/ApplicationView"),
    },

    {
        name: "prequalifyApplicationNext",
        path: "/providers/:providerKey/modes/prequalify/applicationNext",
        meta: { step: StepId.APPLICANT_INFO },
        redirect: "/providers/:providerKey/prequalifyAgree",
    },

    {
        name: "prescreenApplicationNext",
        path: "/providers/:providerKey/modes/prescreen/applicationNext",
        meta: { step: StepId.APPLICANT_INFO },
        redirect: "/providers/:providerKey/prequalifyAgree",
    },

    {
        name: "prequalifyOfferReviewNext",
        path: "/providers/:providerKey/modes/prequalify/offerReviewNext",
        meta: { step: StepId.ACCEPT_OFFER },
        redirect: "/providers/:providerKey/terms",
    },

    {
        name: "prescreenOfferReviewNext",
        path: "/providers/:providerKey/modes/prescreen/offerReviewNext",
        meta: { step: StepId.ACCEPT_OFFER },
        redirect: "/providers/:providerKey/terms",
    },

    {
        name: "checkCalifornia",
        path: "/providers/:providerKey/checkCalifornia",
        meta: {
            step: StepId.ACCEPT_OFFER,
            transient: true,
        },
        component: () => import("@/views/apply/CheckCaliforniaView"),
    },

    {
        name: "checkCaliforniaNext",
        path: "/providers/:providerKey/checkCaliforniaNext",
        meta: { step: StepId.ACCEPT_OFFER },
        redirect: "/providers/:providerKey/terms",
    },
    {
        name: "error",
        path: "/providers/:providerKey/error",
        meta: { step: StepId.COMPLETE, stepper: false },
        component: () => import("@/views/apply/ErrorView"),
    },
    {
        name: "acceptOfferError",
        path: "/providers/:providerKey/acceptOfferError",
        redirect: "/providers/:providerKey/error",
    },
    {
        name: "offerReview",
        path: "/providers/:providerKey/offerReview",
        component: () => import("@/views/apply/OfferReviewView.vue"),
    },
    {
        name: "nooffer",
        path: "/providers/:providerKey/nooffer",
        meta: { step: StepId.COMPLETE },
        component: () => import("@/views/apply/NoOfferView"),
    },
    {
        name: "preapproved",
        path: "/providers/:providerKey/preapproved",
        redirect: "/providers/:providerKey/prequalified",
    },
    {
        name: "prequalified",
        path: "/providers/:providerKey/prequalified",
        redirect: "/providers/:providerKey/paymentPlans",
    },
    {
        name: "paymentPlans",
        path: "/providers/:providerKey/paymentPlans",
        meta: { step: StepId.PAYMENT_OPTIONS },
        component: () => import("@/views/apply/PaymentPlansView"),
    },
    {
        name: "prequalifyAgree",
        path: "/providers/:providerKey/prequalifyAgree",
        meta: { step: StepId.APPLICANT_INFO, disableProviderSwitch: true },
        redirect: "/providers/:providerKey/prequalifyAgreeNext",
    },
    {
        name: "prequalifyAgreeNext",
        path: "/providers/:providerKey/prequalifyAgreeNext",
        meta: { step: StepId.APPLICANT_INFO, disableProviderSwitch: true },
        component: () => import("@/views/apply/PrequalifyAgreeNext"),
    },
    {
        name: "prequalifySubmit",
        path: "/providers/:providerKey/prequalifySubmit",
        meta: {
            step: StepId.PAYMENT_OPTIONS,
            transient: true,
        },
        component: () => import("@/views/apply/PrequalifySubmitView"),
    },
    {
        name: "patchSubmit",
        path: "/providers/:providerKey/patchSubmit",
        meta: {
            step: StepId.ACCEPT_OFFER,
            transient: true,
        },
        component: () => import("@/views/apply/PatchSubmitView"),
    },
    {
        name: "offerReviewNext",
        path: "/providers/:providerKey/offerReviewNext",
        redirect: "/providers/:providerKey/thanks",
    },
    {
        name: "patchSuccessful",
        path: `/providers/:providerKey/patchSuccessful`,
        redirect: "/providers/:providerKey/paymentPlans",
    },
    {
        name: "paymentPlanReview",
        path: "/providers/:providerKey/paymentPlanReview",
        meta: { step: StepId.PAYMENT_OPTIONS },
        component: () => import("@/views/apply/PaymentPlanReviewView"),
    },
    {
        name: "prescreen",
        path: "/providers/:providerKey/prescreen",
        meta: { stepper: false },
        component: () => import("@/views/apply/PrescreenView"),
    },
    {
        name: "resume",
        path: "/providers/:providerKey/resume",
        meta: { step: StepId.PAYMENT_OPTIONS, stepper: false },
        component: () => import("@/views/apply/ResumeView"),
    },
    {
        name: "resumeFromOpen",
        path: "/providers/:providerKey/resume/from-open",
        meta: { step: StepId.PAYMENT_OPTIONS },
        redirect: _ => {
            return `/providers/:providerKey/modes/${applicationState.applyMode}/application`
        },
    },
    {
        name: "resumeWithExistingAccount",
        path: "/providers/:providerKey/resume/with-existing-account",
        meta: { step: StepId.PAYMENT_OPTIONS },
        redirect: "/providers/:providerKey/paymentPlans",
    },
    {
        name: "resumeFromPaymentPlanReview",
        path: "/providers/:providerKey/resume/from-payment-plan-review",
        meta: { step: StepId.PAYMENT_OPTIONS },
        redirect: "/providers/:providerKey/paymentPlanReview",
    },
    {
        name: "resumeFromPrequalifiedReview",
        path: "/providers/:providerKey/resume/from-prequalified",
        meta: { step: StepId.PAYMENT_OPTIONS },
        redirect: "/providers/:providerKey/prequalified",
    },

    {
        name: "thanks",
        path: "/providers/:providerKey/thanks",
        meta: { step: StepId.COMPLETE },
        component: () => import("@/views/apply/ThanksView"),
    },
    {
        name: "acceptOfferSubmit",
        path: "/providers/:providerKey/acceptOfferSubmit",
        component: () => import("@/views/apply/AcceptOfferSubmitView"),
    },
    {
        name: "approved",
        path: `/providers/:providerKey/approved`,
        meta: { step: StepId.COMPLETE },
        component: () => import("@/views/apply/ApplicationApprovedView"),
    },
    {
        name: "declined",
        path: "/providers/:providerKey/declined",
        meta: { step: StepId.COMPLETE, stepper: false },
        component: () => import("@/views/apply/DeclinedView"),
    },
    {
        name: "pending",
        path: "/providers/:providerKey/pending",
        meta: { step: StepId.COMPLETE, stepper: false },
        component: () => import("@/views/apply/PendingView"),
    },
]
